export default {
    template: `
        <div id="loader"></div>
        <ui-view class="frame-wrapper"></ui-view>
        <upload-progress></upload-progress>
    `,
    resolve: {
        translations: ($rootScope, $q) => {
            const deferred = $q.defer();
            $rootScope.$on('$translateLoadingEnd', deferred.resolve);
            return deferred.promise;
        }
    },
    controller ($timeout, $state, $window, $location, $anchorScroll, $scope, ngProgressFactory) {
        // Fix scroll position
        const scrollPosCache = {};
        const loader = ngProgressFactory.createInstance();

        $scope.$on('$stateChangeStart', () => {
            loader.start();
            if ($state.current) {
                scrollPosCache[$state.href($state.current.name, $state.params, { absolute: false })] = [$window.pageXOffset, $window.pageYOffset];
            }
        });
        $scope.$on('$stateChangeSuccess', () => {
            loader.complete();
            if ($location.hash()) {
                $anchorScroll();
            }
            else {
                const prevScrollPos = scrollPosCache[$state.href($state.current.name, $state.params, { absolute: false })] || [0, 0];
                $timeout(() => {
                    $window.scrollTo(prevScrollPos[0], prevScrollPos[1]);
                }, 0);
            }
        });

        $scope.$on('$stateChangeError', () => loader.stop());
        $scope.$on('$stateChangeCancel', () => loader.stop());
    }
};



// WEBPACK FOOTER //
// ./src/app/layouts/application/index.js